import {
  CHECK_SERVICE_OPEN_RESTAURANT_SUCCESS,
  FETCH_DATA_RESTAURANT_SUCCESS,
  REQUEST_UPDATE_FROZEN_SLOTS_SUCCESS,
} from "../types/restaurant.types";
import { deepClone, sortWeight } from "../../utils/utils";

const initialState = {
  infoRestaurant: {
    paymentMethod: {
      type: "none",
      token: "",
    },
    menuWithProducts: true,
    timePrepareOrder: "",
    nextHourOrderPickup: "",
    messageService: "",
    diffWithdrawal: 15,
    slotDuration: 15,
    idMenuSelected: "",
    idLaddition: null,
    serviceOpen: true,
    serviceOpenLater: true,
    messageToken: "",
    deliveryArea: [],
    description: "",
    openingDate: [],
    closingDate: {},
    dataMessage: "",
    isDemo: false,
    currency: "",
    images: [],
    address: {
      street_number: "",
      zip_code: "",
      country: "",
      street: "",
      city: "",
      long: "",
      lat: "",
    },
    slogan: "",
    phone: "",
    menu: [],
    name: "",
    id: "",
    logRocket: false,
    disabled: {
      active: false,
      period: null,
    },
    timezone: '',
  },
};

const reducer = function restaurantReducer(state = initialState, action) {
  const newState = deepClone(state);
  switch (action.type) {
    case REQUEST_UPDATE_FROZEN_SLOTS_SUCCESS:
      const { response } = action;
      newState.infoRestaurant.slotFreeze = response.data;
      return newState;
    case FETCH_DATA_RESTAURANT_SUCCESS:
      const dataRestaurant = action.datas.resultRestaurant;
      const dataMenu = action.datas.resultMenu;

      let slotFreeze = {};
      try {
        if (dataRestaurant.slot_freeze)
          slotFreeze = JSON.parse(dataRestaurant.slot_freeze);
      } catch (e) {}

      newState.infoRestaurant.menuWithProducts =
        dataRestaurant.menu_with_products;
      newState.infoRestaurant.id = dataRestaurant.id;
      newState.infoRestaurant.name = dataRestaurant.name;
      newState.infoRestaurant.slogan = dataRestaurant.slogan;
      newState.infoRestaurant.timezone = dataRestaurant.timezone;
      //TODO CHECK WITH PAY+
      //ADD SPECIFIC KEY (STRIPE OR PAY+)?
      newState.infoRestaurant.paymentMethod = dataRestaurant.payment_method;
      newState.logRocket = !!dataRestaurant.logrocket;
      if (!dataRestaurant.menu_with_products) {
        return newState;
      }
      newState.infoRestaurant.deliveryArea = recoverZipCode(
        dataRestaurant.delivery_area
      );
      newState.infoRestaurant.menu = sortMenuByWeight(dataMenu);
      newState.infoRestaurant.idMenuSelected = dataRestaurant.idMenuSelected;
      newState.infoRestaurant.openingDate = dataRestaurant.opening_date;
      newState.infoRestaurant.closingDate = dataRestaurant.closing_date;
      newState.infoRestaurant.timePrepareOrder =
        dataRestaurant.time_prepare_order;
      newState.infoRestaurant.description = dataRestaurant.description;
      newState.infoRestaurant.idLaddition = dataRestaurant.id_laddition;
      newState.infoRestaurant.isDemo = dataRestaurant.is_demo;
      newState.infoRestaurant.phone = dataRestaurant.phone;
      newState.infoRestaurant.address = dataRestaurant.address;
      newState.infoRestaurant.currency = dataRestaurant.currency.symbol;
      newState.infoRestaurant.images = dataRestaurant.images;
      newState.infoRestaurant.slotFreeze = slotFreeze;
      newState.infoRestaurant.slotDuration = dataRestaurant.slot_duration;
      newState.infoRestaurant.disabled = dataRestaurant.disabled;
      return newState;
    case CHECK_SERVICE_OPEN_RESTAURANT_SUCCESS:
      return resultIfServiceOpen(newState, action.response);
    default:
      return newState;
  }
};

function recoverZipCode(deliveryArea) {
  return deliveryArea.map((data) => data.postalCode);
}

function resultIfServiceOpen(state, data) {
  const {
    restaurant_open,
    message,
    dataMessage,
    restaurant_open_later,
    restaurant_next_hour_order_pickup,
  } = data;
  state.infoRestaurant.serviceOpen = restaurant_open;
  state.infoRestaurant.messageService = message;
  state.infoRestaurant.dataMessage = dataMessage;
  state.infoRestaurant.serviceOpenLater = restaurant_open_later;
  state.infoRestaurant.nextHourOrderPickup = restaurant_next_hour_order_pickup;

  return state;
}

function sortMenuByWeight(menu) {
  const sortDatasIn = menu.filter((category) => {
    const isMenuCategory = category.products.some(
      (prdt) => prdt.type === "menu"
    );
    if (isMenuCategory) {
      const menus = category.products.map((product) => {
        const sortProductsInlevel = product.menu_levels.filter((level) => {
          if (level.products.length) {
            const sortProducts = sortDatas(level.products);
            level.products = sortProducts;
            return level;
          }
        });
        const sortLevels = sortWeight(sortProductsInlevel);
        product.menu_levels = sortLevels;
        return product;
      });
      const sortMenus = sortWeight(menus);
      category.products = sortMenus;
      return category;
    }
    if (category.products.length) {
      const sortProducts = sortDatas(category.products);
      category.products = sortProducts;
      return category;
    }
  });
  const sortProducts = sortWeight(sortDatasIn);
  return sortProducts;
}

function sortDatas(datas) {
  return datas.map((product) => {
    const extraCategories = product.extraCategories.map((extraCate) => {
      const sortData = sortWeight(extraCate.data);
      extraCate.data = sortData;
      return extraCate;
    });
    const sortExtraCategories = sortWeight(extraCategories);
    product.extraCategories = sortExtraCategories;
    return product;
  });
}

export default reducer;
